import React from 'react';
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  InputNumber,
  Button,
  Select,
  Radio,
  Row,
  Col,
  DatePicker,
  Upload
} from 'antd';
import get from 'lodash/get';
import find from 'lodash/find';
import { connect } from 'react-redux';

import { createUserTrainingRequest, createUserTrainingUploadRequest, resetUserTrainingRetriesRequest } from "../../api/requests";
import {
  getUserCreatePermission, getUserShortTimezone, getUserTimezone,
  getUserUpdatePermission, getUserTrainingResetPermission
} from '../../reducers/user/selectors';

import classes from './SettingsUserTrainingForm.css';
import { logout } from "../../reducers/user/actions";
import moment from "moment";

const { Option } = Select;


function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class SettingsUserTrainingForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      retriesResetLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({isSubmitted: true, requestResult: {}});

      if (!err) {
        this.setState({ isLoading: true });

        try {
          let training;

          if (values.has_training_required === 'uploaded') {
            training = new FormData();
            if (values.document_file && values.document_file.file) { training.append('document_file', values.document_file.file); }
            training.append('has_training_required', values.has_training_required);
            training.append('training_completed_date', values.training_completed_date.format('YYYY-MM-DDT')+'12:00');
            training.append('user_training_type', values.user_training_type);
            if (values.user_training_type) {
              training.append('user_training_type_other_comments', values.user_training_type_other_comments ? values.user_training_type_other_comments : '');
            }
            training.append('training_comments', values.training_comments ? values.training_comments: '');

            training.append('site_id', values.site_id);
            await createUserTrainingUploadRequest(this.props.id, training);
          } else {
            training = {...values};
            if (values.training_completed_date) {
              training.training_completed_date = values.training_completed_date.format('YYYY-MM-DDT')+'12:00';
            }
            await createUserTrainingRequest(this.props.id, training);
          }

          this.setState({isLoading: false, requestResult: {type: 'success', message: 'Success'}});

          setTimeout(() => {
            this.setState({ requestResult: {} });
            this.props.onSubmit();
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {type: 'error', message: get(e, 'response.data.message', 'Error')}
          });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  handleResetRetries = async (id) => {
    this.setState({ retriesResetLoading: true });

    try {
      await resetUserTrainingRetriesRequest(id);
      await this.props.getUsersList()
      this.props.onCancel();
    } finally {
      this.setState({ retriesResetLoading: false })
    }
  }

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { userUpdatePermission, userCreatePermission, resetRetriesPermission, id, sites } = this.props;

    const isEditable = id ? userUpdatePermission : userCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            <span>{this.props.username} <Badge count='Training' style={{ backgroundColor: '#2968AE' }} /></span>
          </h4>

          <div>
            <Row gutter={12}>
              <Col lg={12}>
                <label>
                  <b>Site</b>
                  <Form.Item>
                    {getFieldDecorator('site_id', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'training.site_id')
                    })(<Select disabled={!isEditable} placeholder='Select Site ID' style={{ width: '100%'}} allowClear>
                      {sites.map(site => (
                        <Option key={site.id} value={site.id}>{site.code} - {site.name}</Option>
                      ))}
                    </Select>)}
                  </Form.Item>
                </label>
              </Col>
              <Col lg={12}>
                <label>
                  <b>Retries number</b>
                  <Form.Item>
                    {get(this.props, 'training.retries_number', '-')}
                  </Form.Item>
                </label>
              </Col>

              <Col span={24}>
                <div className={classes.formItem}>
                  <b>User requires training</b>
                  <br/>
                  {getFieldDecorator('has_training_required', {
                    initialValue: get(this.props, 'training.has_training_required', ''),
                    rules: [{ required: true, message: 'Required' }]
                  })(
                    <Radio.Group>
                      <Radio value='yes'>Yes</Radio>
                      <Radio value='no'>No</Radio>
                      <Radio value='completed'>Training already completed</Radio>
                      <Radio value='uploaded'>User uploaded certificate</Radio>
                    </Radio.Group>
                  )}
                </div>
              </Col>

              {getFieldValue('has_training_required') === 'no' && <React.Fragment>
                <Col span={24}>
                  <div className={classes.formItem}>
                    <b>Reason</b>
                    <br/>
                    <Form.Item>
                      {getFieldDecorator('training_not_required_comments', {
                        initialValue: get(this.props, 'training.training_not_required_comments', ''),
                        rules: [{ required: true, message: 'Required' }]
                      })(
                        <Input.TextArea />
                      )}
                    </Form.Item>
                  </div>
                </Col>
              </React.Fragment>}

              {getFieldValue('has_training_required') === 'yes' && <React.Fragment>
                <Col span={12}>
                  <label>
                    <b>Training type</b>
                    <Form.Item>
                      {getFieldDecorator('required_training_type', {
                        initialValue: get(this.props, 'training.required_training_type', ''),
                        rules: [{ required: true, message: 'Required' }]
                      })(
                        <Select disabled={!isEditable} placeholder='Select Site ID' style={{ width: '100%'}} allowClear>
                          <Option value="type_1">Type 1</Option>
                          <Option value="type_2">Type 2</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </label>
                </Col>
              </React.Fragment>}

              {getFieldValue('has_training_required') === 'completed' && <React.Fragment>
                <Col span={12}>
                  <div className={classes.formItem}>
                    <b>Training completed date</b>

                    <Form.Item>
                      <div style={{ display: 'flex', alignItems: 'center', width: '220px' }}>
                        {getFieldDecorator('training_completed_date', {
                          rules: [{ required: true, message: 'Required' }],
                          initialValue: get(this.props, 'training.training_completed_date', null) ? moment.utc(get(this.props, 'training.training_completed_date')) : moment.utc(new Date())
                        })(
                          <DatePicker
                            disabled={!isEditable}
                            format='YYYY/MM/DD'
                            disabledDate={(currentDate) => currentDate.diff(moment.now()) > 86400000} />,
                        )}

                        <span style={{width: '35px'}}>
                          &nbsp;{this.props.userShortTimezone || get(find(sites, ({ id }) => id === getFieldValue('site_id')), 'short_tz') || 'UTC'}
                        </span>
                      </div>
                    </Form.Item>
                  </div>
                </Col>


                <Col span={12}>
                  <br/>
                  <div style={{ padding: '5px 0 0'}}>
                    {get(this.props, 'training.certificate_link') && <a href={get(this.props, 'training.certificate_link')} target='_blank'>Certificate link</a>}
                  </div>
                </Col>

                <Col span={24} />

                <Col span={12}>
                  <div className={classes.formItem}>
                    <b>Type of training</b>
                    <br/>

                    <Form.Item>
                      {getFieldDecorator('user_training_type', {
                        rules: [{ required: true, message: 'Required' }],
                        initialValue: get(this.props, 'training.user_training_type', '')
                      })(
                        <Select placeholder='Select'>
                          <Option value="siv">SIV</Option>
                          <Option value="webinar">Webinar</Option>
                          <Option value="self_training">Self-Training</Option>
                          <Option value="in_person">In Person</Option>
                          <Option value="online_quiz_type_1">Online Quiz - Type 1</Option>
                          <Option value="online_quiz_type_2">Online Quiz - Type 2</Option>
                          <Option value="other">Other</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </div>
                </Col>

                {getFieldValue('user_training_type') === 'other' && <Col span={12}>
                  <div className={classes.formItem}>
                    <b>Other</b>
                    <br/>
                    <Form.Item>
                      {getFieldDecorator('user_training_type_other_comments', {
                        rules: [{ required: true, message: 'Required' }],
                        initialValue: get(this.props, 'training.user_training_type_other_comments')
                      })(
                        <Input.TextArea />
                      )}
                    </Form.Item>
                  </div>
                </Col>}

                <Col span={24}>
                  <div className={classes.formItem}>
                    <b>Comments</b>
                    <br/>
                    {getFieldDecorator('training_comments', {
                      initialValue: get(this.props, 'training.training_comments')
                    })(
                      <Input.TextArea />
                    )}
                  </div>
                </Col>
              </React.Fragment>}

              {getFieldValue('has_training_required') === 'uploaded' && <React.Fragment>
                <Col span={24}>
                  <div className={classes.formItem}>
                    <b>Training completed date</b>
                    <Form.Item>
                      <div style={{ display: 'flex', alignItems: 'center', width: '220px' }}>
                        {getFieldDecorator('training_completed_date', {
                          rules: [{ required: true, message: 'Required' }],
                          initialValue: get(this.props, 'training.training_completed_date', null) ? moment.utc(get(this.props, 'training.training_completed_date')) : moment.utc(new Date())
                        })(
                          <DatePicker
                            disabled={!isEditable}
                            format='YYYY/MM/DD'
                            disabledDate={(currentDate) => currentDate.diff(moment.now()) > 86400000} />,
                        )}

                        <span style={{width: '35px'}}>
                          &nbsp;{this.props.userShortTimezone || get(find(sites, ({ id }) => id === getFieldValue('site_id')), 'short_tz') || 'UTC'}
                        </span>
                      </div>
                    </Form.Item>
                  </div>
                </Col>

                <Col span={12}>
                  <div className={classes.formItem}>
                    <b>Type of training</b>
                    <br/>
                    {getFieldDecorator('user_training_type', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'training.user_training_type')
                    })(
                      <Select placeholder='Select'>
                        <Option value="siv">SIV</Option>
                        <Option value="webinar">Webinar</Option>
                        <Option value="self_training">Self-Training</Option>
                        <Option value="in_person">In Person</Option>
                        <Option value="online_quiz_type_1">Online Quiz - Type 1</Option>
                        <Option value="online_quiz_type_2">Online Quiz - Type 2</Option>
                        <Option value="other">Other</Option>
                      </Select>
                    )}
                  </div>
                </Col>

                {getFieldValue('user_training_type') === 'other' && <Col span={12}>
                  <div className={classes.formItem}>
                    <b>Other</b>
                    <br/>
                    <Form.Item>
                      {getFieldDecorator('user_training_type_other_comments', {
                        rules: [{ required: true, message: 'Required' }],
                        initialValue: get(this.props, 'training.user_training_type_other_comments')
                      })(
                        <Input.TextArea />
                      )}
                    </Form.Item>
                  </div>
                </Col>}

                <Col span={24} />

                <Col span={12}>
                  <div className={classes.formItem}>
                    <b>Upload certificate</b>
                    <br/>
                    <Form.Item>
                      {getFieldDecorator('document_file', {
                        initialValue: '',
                      })(
                        <Upload  disabled={!isEditable} accept='.doc,.docx,.odt,.txt,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.gif' action='' beforeUpload={() => false} multiple={false} fileList={get(this.props.form.getFieldValue('document_file'), 'fileList', []).slice(-1)}>
                          <Button>
                            <Icon type="upload" />
                            {!this.props.form.getFieldValue('document_file') && get(this.props, 'training.certificate_link') ? 'Change file' : 'Add Certificate' }
                          </Button>
                        </Upload>
                      )}
                    </Form.Item>
                  </div>
                </Col>

                <Col span={12}>
                  <br/>
                  <div style={{ padding: '5px 0 0'}}>
                    {!this.props.form.getFieldValue('document_file') && get(this.props, 'training.certificate_link') && <a href={get(this.props, 'training.certificate_link')} target='_blank'>Certificate link</a>}
                  </div>
                </Col>

                <Col span={24}>
                  <div className={classes.formItem}>
                    <b>Comments</b>
                    <br/>
                    {getFieldDecorator('training_comments', {
                      initialValue: get(this.props, 'training.training_comments')
                    })(
                      <Input.TextArea />
                    )}
                  </div>
                </Col>

              </React.Fragment>}
            </Row>
          </div>

          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>

            {isEditable && (<div>
              <Button type="primary" htmlType="submit" className={classes.submitButton}>
                Save
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;</div>
            )}

            {/*{currentStep !== 0 && (<div><Button type="default" htmlType="button" className={classes.submitButton} onClick={this.setStep(0)}>
              Prev
            </Button>&nbsp; &nbsp;</div>)}*/}

            <Button type="default" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
              Cancel
            </Button>
            {get(this.props, 'training.retries_number') > 0 && resetRetriesPermission &&
              <React.Fragment>
                &nbsp; &nbsp;
                <Button loading={this.state.retriesResetLoading} type="default" htmlType="button" className={classes.submitButton} onClick={() => this.handleResetRetries(get(this.props, 'training.id'))}>
                  Reset training retries
                </Button>
              </React.Fragment>
            }
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  userCreatePermission: getUserCreatePermission(state),
  userUpdatePermission: getUserUpdatePermission(state),
  resetRetriesPermission: getUserTrainingResetPermission(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'user' })(connect(mapStateToProps, mapDispatchToProps)(SettingsUserTrainingForm));



// WEBPACK FOOTER //
// ./src/components/SettingsUserTrainingForm/SettingsUserTrainingForm.js